<template>
  <div :padding="false">
    <div class="warm-tip">【温馨提示】为了全方位保障用户资产安全，同时响应国家反洗钱政策，请您配合完成相关验证。</div>
    <div class="form border-1px mb-15">
      <h3 class="form-caption">个人信息</h3>
      <div class="form-row-wrap">
        <div class="clearfix form-row">
          <div class="form-group">
            <q-field
              class="quasar-qfield glay-bg"
              :error="$v.form.lastname.$error"
              :error-label="getErrorLabel($v.form.lastname, 'lastname')">
              <q-input
                v-model="form.lastname"
                @blur="$v.form.lastname.$touch"
                :class="{'invalid-class': $v.form.lastname.$error}"
                float-label="请输入英文/拼音名字 例：Ming"></q-input>
            </q-field>
          </div>
          <div class="form-group">
            <q-field
              class="quasar-qfield glay-bg"
              :error="$v.form.name.$error"
              :error-label="getErrorLabel($v.form.name, 'name')">
              <q-input
                v-model="form.name"
                @blur="$v.form.name.$touch"
                :class="{'invalid-class': $v.form.name.$error}"
                float-label="请输入英文/拼音姓氏 例：Li"></q-input>
            </q-field>
          </div>
        </div>
        <div class="clearfix form-row">
          <div class="form-group">
            <q-field
              class="quasar-qfield glay-bg"
              :error="$v.form.realName.$error"
              :error-label="getErrorLabel($v.form.realName, 'realName')">
              <q-input
                v-model="form.realName"
                @blur="$v.form.realName.$touch"
                :class="{'invalid-class': $v.form.realName.$error}"
                float-label="请填写您的身份证姓名"></q-input>
            </q-field>
          </div>
          <div class="form-group">
            <q-field
              class="quasar-qfield glay-bg"
              :error="$v.form.nickName.$error"
              :error-label="getErrorLabel($v.form.nickName, 'nickName')">
              <q-input
                v-model="form.nickName"
                @blur="$v.form.nickName.$touch"
                :class="{'invalid-class': $v.form.nickName.$error}"
                float-label="请填写您的昵称"></q-input>
            </q-field>
          </div>
        </div>
        <div class="clearfix form-row">
          <div class="form-group birthday-group">
            <label class="form-label">出生日期</label>
            <div class="row justify-between birthday-choose-row"
                 :class="{'invalid-class': $v.form.day.$error || $v.form.month.$error || $v.form.year.$error || $v.form.birthday.$error}">
              <q-field
                error-label=" ">
                <q-select
                  v-model="form.day"
                  class="quasar-qselect glay-bg"
                  :class="{'invalid-class': $v.form.day.$error}"
                  float-label="日期"
                  :options="getDays"></q-select>
              </q-field>
              <q-field
                error-label=" ">
                <q-select
                  v-model="form.month"
                  class="quasar-qselect glay-bg"
                  :class="{'invalid-class': $v.form.month.$error}"
                  float-label="月份"
                  :options="getMonth"></q-select>
              </q-field>
              <q-field
                error-label=" ">
                <q-select
                  v-model="form.year"
                  class="quasar-qselect glay-bg"
                  :class="{'invalid-class': $v.form.year.$error}"
                  float-label="年份"
                  :options="getYears"></q-select>
              </q-field>
            </div>
            <input type="hidden" v-model="getBirthday">
            <!--这个error-tip因为是三个表单控制一个error-tip显示，所以特殊情况特殊处理-->
            <div class="color-error error-tip">
              {{birthday_errorMsg}}
            </div>
          </div>
          <div class="form-group"></div>
        </div>
        <div class="clearfix form-row">
          <div class="form-group">
            <VueCountryIntl
              class="quasar-country-select glay-bg"
              :class="{'invalid-class': $v.form.countryCode.$error}"
              v-model="form.countryCode"
              model="country"
              disableCountry="Malaysia"
              @onchange="countrySelect"
              placeholder="请选择您的国籍"></VueCountryIntl>
            <div class="color-error error-tip pt-5">
              <span v-show="$v.form.countryCode.$error && !$v.form.countryCode.required">请选择您的国籍</span>
            </div>
          </div>
          <div class="form-group">
            <q-field
              :error="$v.form.sex.$error"
              :error-label="getErrorLabel($v.form.sex, 'sex')">
              <q-select
                v-model="form.sex"
                class="quasar-qselect glay-bg"
                :class="{'invalid-class': $v.form.sex.$error}"
                float-label="请选择您的性别"
                :options="gender"></q-select>
            </q-field>
          </div>
        </div>
        <div class="clearfix form-row">
          <div class="form-group">
            <q-field
              :error="$v.form.identityType.$error"
              :error-label="getErrorLabel($v.form.identityType, 'identityType')">
              <q-select
                v-model="form.identityType"
                class="quasar-qselect glay-bg"
                :class="{'invalid-class': $v.form.identityType.$error}"
                float-label="请选择证件类型"
                :options="certificateTypes"></q-select>
            </q-field>
          </div>
          <div class="form-group">
            <q-field
              class="quasar-qfield glay-bg"
              :error="$v.form.identityNo.$error"
              :error-label="getErrorLabel($v.form.identityNo, 'identityNo')">
              <q-input
                v-model="form.identityNo"
                @blur="$v.form.identityNo.$touch"
                :class="{'invalid-class': $v.form.identityNo.$error}"
                float-label="请填写您的证件号码"></q-input>
            </q-field>
          </div>
        </div>
      </div>
    </div>

    <div class="form border-1px mb-30">
      <h3 class="form-caption">
        <span class="inline-block mr-20">本人证件照片</span>
        <span class="upload-file-format-tip">* 请按照要求上传您身份证的正面照片，仅支持JPG、BMP、PNG 格式</span>
      </h3>
      <div class="mb-30">
        <div class="upload-row row">
          <div class="file-opt-area" v-if="uploaderCanInit" :class="{'invalid-class': $v.form.identifyImgUrl1.$error}">
            <UploadImg
              @uploadSuccess="_uploadSuccess1"
              @error="_error">
              <div class="text-center">
                <div class="color-666 mb-5">身份证正面图</div>
                <div class="color-ccc font-12">图片大小：不超过5MB</div>
              </div>
            </UploadImg>
          </div>
          <div class="template-tip">样本图片
            <q-icon name="play_arrow" class="font-22 inline-block vertical-middle"></q-icon>
          </div>
          <div class="template-img">
            <img src="../../../assets/images/front.png" alt="">
          </div>
        </div>
        <input type="hidden" v-model="form.identifyImgUrl1">
        <div class="color-error error-tip">
          <span v-show="$v.form.identifyImgUrl1.$error && !$v.form.identifyImgUrl1.required">请上传证件正面照片</span>
        </div>
      </div>

      <div class="mb-30">
        <div class="upload-row row">
          <div class="file-opt-area" v-if="uploaderCanInit" :class="{'invalid-class': $v.form.identifyImgUrl2.$error}">
            <UploadImg
              @uploadSuccess="_uploadSuccess2"
              @error="_error">
              <div class="text-center">
                <div class="color-666 mb-5">身份证照片后视图</div>
                <div class="color-ccc font-12">图片大小：不超过5MB</div>
              </div>
            </UploadImg>
          </div>
          <div class="template-tip">样本图片
            <q-icon name="play_arrow" class="font-22 inline-block vertical-middle"></q-icon>
          </div>
          <div class="template-img">
            <img src="../../../assets/images/reverse-side.png" alt="">
          </div>
        </div>
        <input type="hidden" v-model="form.identifyImgUrl2">
        <div class="color-error error-tip">
          <span v-show="$v.form.identifyImgUrl2.$error && !$v.form.identifyImgUrl2.required">请上传证件反面照片</span>
        </div>
      </div>

      <div class="mb-30">
        <div class="upload-row row">
          <div class="file-opt-area" v-if="uploaderCanInit" :class="{'invalid-class': $v.form.identifyImgUrl3.$error}">
            <UploadImg
              @uploadSuccess="_uploadSuccess3"
              @error="_error">
              <div class="text-center">
                <div class="color-666 mb-5">手持身份证前视图</div>
                <div class="color-ccc font-12">图片大小：不超过5MB</div>
              </div>
            </UploadImg>
          </div>
          <div class="template-tip">样本图片
            <q-icon name="play_arrow" class="font-22 inline-block vertical-middle"></q-icon>
          </div>
          <div class="template-img">
            <img src="../../../assets/images/in-hand.png" alt="">
          </div>
        </div>
        <input type="hidden" v-model="form.identifyImgUrl3">
        <div class="color-error error-tip">
          <span v-show="$v.form.identifyImgUrl3.$error && !$v.form.identifyImgUrl3.required">请上传手持证件照片</span>
        </div>
      </div>

    </div>
    <div class="form border-1px mb-15">
      <h3 class="form-caption">居住地址</h3>
      <div class="form-row-wrap">
        <div class="clearfix form-row">
          <div class="form-group">
            <VueCountryIntl
              disableCountry="Malaysia"
              class="quasar-country-select glay-bg"
              v-model="form.countryCode"
              @onchange="_countrySelect"></VueCountryIntl>
            <div class="color-error error-tip pt-5">
              <span v-show="$v.form.countryCode.$error && !$v.form.countryCode.required">请选择居住地址</span>
            </div>
          </div>
          <div class="form-group">
            <q-field
              class="quasar-qfield glay-bg"
              :error="$v.form.province.$error"
              :error-label="getErrorLabel($v.form.province, 'province')">
              <q-input
                v-model="form.province"
                @blur="$v.form.province.$touch"
                :class="{'invalid-class': $v.form.province.$error}"
                float-label="省/市/自治区（或者如果不适合请填NA）" />
            </q-field>
          </div>
        </div>
        <div class="clearfix form-row">
          <div class="form-group">
            <q-field
              class="quasar-qfield glay-bg"
              :error="$v.form.city.$error"
              :error-label="getErrorLabel($v.form.city, 'city')">
              <q-input
                v-model="form.city"
                @blur="$v.form.city.$touch"
                :class="{'invalid-class': $v.form.city.$error}"
                float-label="城市/乡镇" />
            </q-field>
          </div>
          <div class="form-group">
            <q-field
              class="quasar-qfield glay-bg"
              :error="$v.form.district.$error"
              :error-label="getErrorLabel($v.form.district, 'district')">
              <q-input
                v-model="form.district"
                @blur="$v.form.district.$touch"
                :class="{'invalid-class': $v.form.district.$error}"
                float-label="区" />
            </q-field>
          </div>
        </div>
        <div class="clearfix form-row">
          <div class="form-group">
            <q-field
              class="quasar-qfield glay-bg"
              :error="$v.form.buildingNumber.$error"
              :error-label="getErrorLabel($v.form.buildingNumber, 'buildingNumber')">
              <q-input
                v-model="form.buildingNumber"
                @blur="$v.form.buildingNumber.$touch"
                :class="{'invalid-class': $v.form.buildingNumber.$error}"
                float-label="建筑名称/门牌号" />
            </q-field>
          </div>
          <div class="form-group">
            <q-field
              class="quasar-qfield glay-bg"
              :error="$v.form.street.$error"
              :error-label="getErrorLabel($v.form.street, 'street')">
              <q-input
                v-model="form.street"
                @blur="$v.form.street.$touch"
                :class="{'invalid-class': $v.form.street.$error}"
                float-label="街道名（或者如果不适合请填NA）" />
            </q-field>
          </div>
        </div>
        <div class="clearfix form-row">
          <div class="form-group">
            <q-field
              class="quasar-qfield glay-bg"
              :error="$v.form.apartmentNumber.$error"
              :error-label="getErrorLabel($v.form.apartmentNumber, 'apartmentNumber')">
              <q-input
                v-model="form.apartmentNumber"
                @blur="$v.form.apartmentNumber.$touch"
                :class="{'invalid-class': $v.form.apartmentNumber.$error}"
                float-label="公寓号" />
            </q-field>
          </div>
          <div class="form-group">
            <q-field
              class="quasar-qfield glay-bg"
              :error="$v.form.zipCode.$error"
              :error-label="getErrorLabel($v.form.zipCode, 'zipCode')">
              <q-input
                v-model="form.zipCode"
                @blur="$v.form.zipCode.$touch"
                :class="{'invalid-class': $v.form.zipCode.$error}"
                float-label="邮政邮编（或者不适合请填NA）" />
            </q-field>
          </div>
        </div>
      </div>
    </div>

    <div class="form border-1px mb-15">
      <h3 class="form-caption">资金状况</h3>
      <div class="form-row-wrap">
        <div class="clearfix form-row">
          <div class="form-group">
            <q-field
              :error="$v.form.employmentStatus.$error"
              :error-label="getErrorLabel($v.form.employmentStatus, 'employmentStatus')">
              <q-select
                v-model="form.employmentStatus"
                class="quasar-qselect glay-bg"
                :class="{'invalid-class': $v.form.employmentStatus.$error}"
                float-label="就业状况"
                @input="_employmentStatusSelect"
                :options="workStatus"></q-select>
            </q-field>
          </div>
          <div class="form-group">
            <q-field
              :error="$v.form.industry.$error"
              :error-label="getErrorLabel($v.form.industry, 'industry')">
              <q-select
                v-model="form.industry"
                class="quasar-qselect glay-bg"
                :class="{'invalid-class': $v.form.industry.$error}"
                float-label="行业"
                @input="_industrySelect"
                :options="industries"></q-select>
            </q-field>
          </div>
        </div>
        <div class="clearfix form-row">
          <div class="form-group">
            <q-field
              class="quasar-qfield glay-bg"
              :error="$v.form.jobTitle.$error"
              :error-label="getErrorLabel($v.form.jobTitle, 'jobTitle')">
              <q-input
                v-model="form.jobTitle"
                @blur="$v.form.jobTitle.$touch"
                :class="{'invalid-class': $v.form.jobTitle.$error}"
                float-label="职位名称/描述" />
            </q-field>
          </div>
          <div class="form-group">
            <q-field
              class="quasar-qfield glay-bg"
              :error="$v.form.companyName.$error"
              :error-label="getErrorLabel($v.form.companyName, 'companyName')">
              <q-input
                v-model="form.companyName"
                @blur="$v.form.companyName.$touch"
                :class="{'invalid-class': $v.form.companyName.$error}"
                float-label="雇主名称" />
            </q-field>
          </div>
        </div>

        <div class="clearfix form-row">
          <div class="form-group">
            <VueCountryIntl
              v-model="form.employerCountryCode"
              class="quasar-country-select glay-bg"
              placeholder="请选择雇主国家/地区"
              disableCountry="Malaysia"
              @onchange="_employerCountrySelect"></VueCountryIntl>
            <div class="color-error error-tip pt-5">
              <span v-show="$v.form.employerCountryCode.$error && !$v.form.employerCountryCode.required">请选择雇主国家/地区</span>
            </div>
          </div>
          <div class="form-group">
            <q-field
              class="quasar-qfield glay-bg"
              :error="$v.form.employerProvince.$error"
              :error-label="getErrorLabel($v.form.employerProvince, 'employerProvince')">
              <q-input
                v-model="form.employerProvince"
                @blur="$v.form.employerProvince.$touch"
                :class="{'invalid-class': $v.form.employerProvince.$error}"
                float-label="雇主州/省（请填写英文字母）" />
            </q-field>
          </div>
        </div>
        <div class="clearfix form-row">
          <div class="form-group">
            <q-field
              class="quasar-qfield glay-bg"
              :error="$v.form.employerCity.$error"
              :error-label="getErrorLabel($v.form.employerCity, 'employerCity')">
              <q-input
                v-model="form.employerCity"
                @blur="$v.form.employerCity.$touch"
                :class="{'invalid-class': $v.form.employerCity.$error}"
                float-label="雇主城市或镇（填写英文字母）" />
            </q-field>
          </div>
          <div class="form-group">
            <q-field
              class="quasar-qfield glay-bg"
              :error="$v.form.employerDistrict.$error"
              :error-label="getErrorLabel($v.form.employerDistrict, 'employerDistrict')">
              <q-input
                v-model="form.employerDistrict"
                @blur="$v.form.employerDistrict.$touch"
                :class="{'invalid-class': $v.form.employerDistrict.$error}"
                float-label="雇主区（填写英文字母）" />
            </q-field>
          </div>
        </div>
        <div class="clearfix form-row">
          <div class="clearfix form-row">
            <div class="form-group">
              <q-field
                class="quasar-qfield glay-bg"
                :error="$v.form.employerBuildingNumber.$error"
                :error-label="getErrorLabel($v.form.employerBuildingNumber, 'employerBuildingNumber')">
                <q-input
                  v-model="form.employerBuildingNumber"
                  @blur="$v.form.employerBuildingNumber.$touch"
                  :class="{'invalid-class': $v.form.employerBuildingNumber.$error}"
                  float-label="雇主建筑名称/门牌号" />
              </q-field>
            </div>
            <div class="form-group">
              <q-field
                class="quasar-qfield glay-bg"
                :error="$v.form.employerStreet.$error"
                :error-label="getErrorLabel($v.form.employerStreet, 'employerStreet')">
                <q-input
                  v-model="form.employerStreet"
                  @blur="$v.form.employerStreet.$touch"
                  :class="{'invalid-class': $v.form.employerStreet.$error}"
                  float-label="雇主街道名（或者如果不适合请填NA）" />
              </q-field>
            </div>
          </div>
        </div>
        <div class="clearfix form-row">
          <div class="form-group">
            <q-field
              class="quasar-qfield glay-bg"
              :error="$v.form.employerZipCode.$error"
              :error-label="getErrorLabel($v.form.employerZipCode, 'employerZipCode')">
              <q-input
                v-model="form.employerZipCode"
                @blur="$v.form.employerZipCode.$touch"
                :class="{'invalid-class': $v.form.employerZipCode.$error}"
                float-label="雇主邮编/邮政编码" />
            </q-field>
          </div>
          <div class="form-group">
            <q-field
              :error="$v.form.sourceIncome.$error"
              :error-label="getErrorLabel($v.form.sourceIncome, 'sourceIncome')">
              <q-select
                v-model="form.sourceIncome"
                class="quasar-qselect glay-bg"
                :class="{'invalid-class': $v.form.sourceIncome.$error}"
                float-label="资金来源"
                @input="_sourceIncomeSelect"
                :options="sourceIncome"></q-select>
            </q-field>
          </div>
        </div>
        <div class="clearfix form-row">
          <div class="form-group">
            <q-field
              :error="$v.form.grossAsset.$error"
              :error-label="getErrorLabel($v.form.grossAsset, 'grossAsset')">
              <q-select
                v-model="form.grossAsset"
                class="quasar-qselect glay-bg"
                :class="{'invalid-class': $v.form.grossAsset.$error}"
                float-label="净价值美元（不包括主要住宅）"
                :options="grossAsset"></q-select>
            </q-field>
          </div>
          <div class="form-group">
            <q-field
              :error="$v.form.expectedInvestment.$error"
              :error-label="getErrorLabel($v.form.expectedInvestment, 'expectedInvestment')">
              <q-select
                v-model="form.expectedInvestment"
                class="quasar-qselect glay-bg"
                :class="{'invalid-class': $v.form.expectedInvestment.$error}"
                float-label="预期投资水平"
                :options="expectedInvestment"></q-select>
            </q-field>
          </div>
        </div>
      </div>
    </div>

    <div class="form border-1px mb-15">
      <h3 class="form-caption">投资经验</h3>
      <div class="form-row-wrap">
        <div class="clearfix form-row">
          <div class="form-group">
            <q-field
              :error="$v.form.hasInvestedStockMarket.$error"
              :error-label="getErrorLabel($v.form.hasInvestedStockMarket, 'hasInvestedStockMarket')">
              <q-select
                v-model="form.hasInvestedStockMarket"
                class="quasar-qselect glay-bg"
                :class="{'invalid-class': $v.form.hasInvestedStockMarket.$error}"
                float-label="你以前投资过股票市场吗"
                :options="hasInvestedStockMarket"></q-select>
            </q-field>
          </div>
          <div class="form-group">
            <q-field
              class="quasar-qfield glay-bg"
              :error="$v.form.stockMarketInvestment.$error"
              :error-label="getErrorLabel($v.form.stockMarketInvestment, 'stockMarketInvestment')">
              <q-input
                v-model="form.stockMarketInvestment"
                @blur="$v.form.stockMarketInvestment.$touch"
                :class="{'invalid-class': $v.form.stockMarketInvestment.$error}"
                float-label="股票投资经验（年数）" />
            </q-field>
          </div>
        </div>
        <div class="clearfix form-row">
          <div class="form-group">
            <q-field
              class="quasar-qfield glay-bg"
              :error="$v.form.derivativeInvestment.$error"
              :error-label="getErrorLabel($v.form.derivativeInvestment, 'derivativeInvestment')">
              <q-input
                v-model="form.derivativeInvestment"
                @blur="$v.form.derivativeInvestment.$touch"
                :class="{'invalid-class': $v.form.derivativeInvestment.$error}"
                float-label="衍生品市场投资经验（年数）" />
            </q-field>
          </div>
          <div class="form-group">
            <q-field
              :error="$v.form.understandDerivativeMarket.$error"
              :error-label="getErrorLabel($v.form.understandDerivativeMarket, 'understandDerivativeMarket')">
              <q-select
                v-model="form.understandDerivativeMarket"
                class="quasar-qselect glay-bg"
                :class="{'invalid-class': $v.form.understandDerivativeMarket.$error}"
                float-label="你了解衍生品市场是如何运作的吗"
                :options="understandDerivativeMarket"></q-select>
            </q-field>
          </div>
        </div>
        <div class="clearfix form-row">
          <div class="form-group">
            <q-field
              :error="$v.form.understandBlockchanAssetTrade.$error"
              :error-label="getErrorLabel($v.form.understandBlockchanAssetTrade, 'understandBlockchanAssetTrade')">
              <q-select
                v-model="form.understandBlockchanAssetTrade"
                class="quasar-qselect glay-bg"
                :class="{'invalid-class': $v.form.understandBlockchanAssetTrade.$error}"
                float-label="你知道你正在采取的风险交易快链资产？"
                :options="understandBlockchanAssetTrade"></q-select>
            </q-field>
          </div>
          <div class="form-group"></div>
        </div>
      </div>
    </div>

    <div class="form border-1px mb-30">
      <h3 class="form-caption">
        <span class="inline-block mr-20">地址证明文件</span>
      </h3>

      <div class="mb-30">
        <div class="upload-row row" :class="{'invalid-class': $v.form.authImgUrl1.$error}">
          <div class="file-opt-area" v-if="uploaderCanInit">
            <UploadImg
              @uploadSuccess="_uploadSuccess1"
              @error="_error">
              <div class="text-center">
                <div class="color-666 mb-5">上传地址证明文件</div>
                <div class="color-ccc font-12">仅支持JPG、BMP、PNG 格式</div>
              </div>
            </UploadImg>
          </div>
        </div>
        <div class="error-tip color-error pt-5">
          <span v-show="$v.form.authImgUrl1.$error && !$v.form.authImgUrl1.required">请上传地址证明图片</span>
        </div>
      </div>
    </div>

    <div class="form border-1px mb-30">
      <h3 class="form-caption">
        <span class="inline-block mr-20">下载，填写，签署，并拍照上传验证表单 (文件下载)</span>
      </h3>

      <div class="mb-30">
        <div class="upload-row row" :class="{'invalid-class': $v.form.authImgUrl2.$error}">
          <div class="file-opt-area" v-if="uploaderCanInit">
            <UploadImg
              @uploadSuccess="_uploadSuccess2"
              @error="_error">
              <div class="text-center">
                <div class="color-666 mb-5">上传验证表单</div>
                <div class="color-ccc font-12">仅支持JPG、BMP、PNG 格式</div>
              </div>
            </UploadImg>
          </div>
        </div>
        <div class="error-tip color-error pt-5">
          <span v-show="$v.form.authImgUrl2.$error && !$v.form.authImgUrl2.required">请上传验证表单图片</span>
        </div>
      </div>
    </div>

    <div class="mb-30 text-center">
      <q-btn
        class="commit-btn"
        label="确认提交"
        @click="submitBtnClick"></q-btn>
    </div>
    <BootstrapModal v-model="layerModalShow" title="身份认证" :backdrop="false">
      <h5 class="certification-notice-caption">请提供能证明您现在住址的单据或证件照片</h5>
      <ol class="certification-notice">
        <li>
          <p class="mb-10">1. 它可以是以下几种</p>

          <ul>
            <li>(1) 官方证件（如：户口簿、税务局、司法机关开具的证件等）</li>
            <li>(2) 物业账单（水、电、天然气）</li>
            <li>(3) 市政公司出具的提供水、电、天然气协议</li>
            <li>(4) 有效的租赁合同</li>
          </ul>
        </li>
        <li>2. 文件必须有官方印章或签字</li>
        <li>3.照片上所有文字或数字必须清晰</li>
        <li>4.文件中所含名字与地址必须在同一页上</li>
        <li>5.用户名必须与身份证或护照上一致</li>
        <li>6.除租赁合同、物业账单外，所有文件必须为近3个月开具的</li>
        <li>7.只接受扫描的或照成照片的文件（高清），电子版文档将不被接受</li>
      </ol>

      <div class="text-right mt-35 pr-15">
        <q-btn label="进入身份认证" class="no-shadow enter-certification-btn" @click="layerModalShow = false" />
      </div>

    </BootstrapModal>
  </div>
</template>

<script>
    import index from './index.js';
    export default index;
</script>

<style lang="stylus" scoped>
  @import "../../../common/styles/mixin/certification.scoped.styl"
  @import "realname.scoped.styl"
</style>
